import styles from './FJEditMenu.module.less';
import SmartIcon from '../../../../../assets/svg/transcribe/smart-optimize.svg?react';
import DeleteIcon from '../../../../../assets/svg/transcribe/magic-edit.svg?react';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MODAL_PARTICLE } from '../../../../../config/dataConfig/FJTextBasedEditingData.js';
import FJActionTextBasedEditingExtension from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditingExtension.js';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';
import freeIconBase from '../../../../../assets/base64/start.js';
import cionIcon from '../../../../../assets/base64/cion-new.js';
import FJToolTip from '../../../../../common/components/FJToolTip/FJToolTip.jsx';
import PropTypes from 'prop-types';
import FJTextBasedEditingConfig from '../../../../../config/appConfig/FJTextBasedEditingConfig.js';

let _time = null;

const MAGIC_LANGUAGE_LIST = Object.keys(MODAL_PARTICLE);

const FJEditMenu = props => {
    const { hideMenu } = props;
    const dispatch = useDispatch();
    const selectedLanguage = useSelector(state => state.textBasedEditing.selectedLanguage);
    const highLightFreeNum = useSelector(state => state.textBasedEditing.highLightFreeNum);
    const isInsufficiency = useSelector(state => {
        return state.common.creditNumber < FJTextBasedEditingConfig.highLightUnitPrice;
    });

    useEffect(() => {
        return () => {
            if (_time) {
                clearTimeout(_time);
                _time = null;
            }
        };
    }, []);

    const _mouseEnter = e => {
        if (_time) clearTimeout(_time);
        _time = setTimeout(() => {
            dispatch(FJActionTextBasedEditingExtension.showIgnoreWordAction());
        }, 300);
    };

    const _mouseLeave = e => {
        if (_time) {
            clearTimeout(_time);
            _time = null;
        }
        dispatch(FJActionTextBasedEditingExtension.hideIgnoreWordAction());
    };

    const _deleteMark = () => {
        dispatch(FJActionTextBasedEditingExtension.removeMarkTextAction());
    };

    const _startAIClippingContent = () => {
        hideMenu && hideMenu();
        dispatch(FJActionTextBasedEditing.aiClippingContentAction());
    };

    const _renderHighLightIcon = () => {
        if (isInsufficiency && highLightFreeNum > 0) {
            const tips =
                highLightFreeNum > 1
                    ? FJLocalStore._('free-tries-left').replace('xxx', highLightFreeNum)
                    : FJLocalStore._('free-trie-left');
            return (
                <FJToolTip title={tips} placement={'top'}>
                    <img src={freeIconBase} className={styles.free_icon} />
                </FJToolTip>
            );
        } else {
            return (
                <div className={styles.credit_button}>
                    <img src={cionIcon} className={styles.credit_icon} />
                    <span className={styles.credit_text}>-{FJTextBasedEditingConfig.highLightUnitPrice}</span>
                </div>
            );
        }
    };

    const _showMagicButton = MAGIC_LANGUAGE_LIST.indexOf(selectedLanguage) !== -1;

    return (
        <div className={styles.box}>
            <div className={styles.item} onClick={_startAIClippingContent}>
                <SmartIcon className={styles.icon} style={{ marginTop: 2 }} />
                <div className={styles.text_box}>
                    <div className={styles.text1}>{FJLocalStore._('highlights')}</div>
                    <div className={styles.text2}>{FJLocalStore._('extract-highlights-with-one-click')}</div>
                </div>
                {_renderHighLightIcon()}
            </div>
            {_showMagicButton && (
                <div
                    className={styles.item}
                    onMouseEnter={_mouseEnter}
                    onMouseLeave={_mouseLeave}
                    onClick={_deleteMark}
                >
                    <DeleteIcon className={styles.icon} />
                    <div className={styles.text_box}>
                        <div className={styles.text1}>{FJLocalStore._('remove-filler-words')}</div>
                        <div className={styles.text2}>{FJLocalStore._('delete-words-like-uh-um-etc')}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

FJEditMenu.propTypes = {
    hideMenu: PropTypes.func,
};

export default FJEditMenu;
